import React from 'react'
import { PaddingType } from './types/stylesTypes'

type SectionPropsType = {
  children: React.ReactNode
  backgroundColor: string
  padding: PaddingType
}

function Section({ backgroundColor, children, padding }: SectionPropsType) {
  const styles: Record<string, string | number> = {
    ...padding,
    width: '100%',
    borderSpacing: 0,
    borderCollapse: 'initial !important',
    backgroundColor,
  }

  return (
    <table
      role="presentation"
      border={0}
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      style={{ width: '100%' }} // overwrite backend preview table width
      className="section-outer"
    >
      <tbody>
        <tr>
          <td align="center">
            <table
              role="presentation"
              border={0}
              cellPadding="0"
              cellSpacing="0"
              width="100%"
              style={styles}
              className="section-inner"
            >
              <tbody>
                <tr>
                  <td align="center">{children}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Section
